import { render, staticRenderFns } from "./AssignPriority.vue?vue&type=template&id=2742861c"
import script from "./AssignPriority.vue?vue&type=script&lang=js"
export * from "./AssignPriority.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports